import styled, {css} from "styled-components"
import SearchResult from "./search-result"
import {spacing, text} from "../../styles/Rythms"
import {elevation} from "../../styles/Elevations"
import {primary} from "../../styles/Colors"
import {device} from "../../styles/Media"

const Popover = css`
  max-height: 65vh;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  z-index: 2;
  left: 50%;
  transform: translateX(-50%);
  margin-top: ${spacing[3]};
  width: calc(100vw - 50px);
  max-width: 30em;
  box-shadow: ${elevation[2]};
  padding: 1em;
  border-radius: 10px;
  background: var(--lightBg);


  @media all and ${device.laptop} {
    left: auto;
    right: 0;
    transform: none;
  }
`

export default styled(SearchResult)`
  display: ${props => (props.show ? `block` : `none`)};

  ${Popover}
  .HitCount {
    display: flex;
    justify-content: center;
    margin-bottom: ${spacing[3]};
    margin-top: ${spacing[1]};
    font-size: ${text.base};
  }

  .Hits {

    ul {
      list-style: none;
      margin-left: 0;
    }

    li.ais-Hits-item {
      transition-duration: 0.2s;
      margin-bottom: 1em;
      text-align: left;
      width: 100%;

      a {
        color: var(--text);
        font-size: ${text.base};
      }

      &:last-child {
        margin-left: 0;
      }

      &:hover {
        transform: translateX(6px);
        padding-left: 6px;
        margin-right: -3px;
        border-left: 3px solid ${primary[40]};
      }
    }

    .ais-Highlight-highlighted {
      background: ${primary[20]};
    }

    .ais-Snippet {
      text-align: left;
      color: var(--lightText);
      font-size: ${text.sm};
      font-weight: normal;

      .ais-Snippet-highlighted {
        background: none;
      }
    }
  }

  .ais-PoweredBy {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: ${text.sm};

    a {
      display: flex;
    }

    svg {
      width: 60px;
      margin-left: ${spacing[1]};
    }
  }
`
